/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExpenseSummary
 */
export interface ExpenseSummary {
    /**
     * 
     * @type {number}
     * @memberof ExpenseSummary
     */
    amountWithoutFeesAndTaxes: number;
    /**
     * 
     * @type {number}
     * @memberof ExpenseSummary
     */
    serviceFeesWithoutTaxes: number;
    /**
     * 
     * @type {number}
     * @memberof ExpenseSummary
     */
    amountWithoutTaxes: number;
    /**
     * 
     * @type {number}
     * @memberof ExpenseSummary
     */
    taxes: number;
    /**
     * 
     * @type {number}
     * @memberof ExpenseSummary
     */
    amountTotalWithFeesAndTaxes: number;
    /**
     * 
     * @type {boolean}
     * @memberof ExpenseSummary
     */
    shouldDisplayFees: boolean;
}

/**
 * Check if a given object implements the ExpenseSummary interface.
 */
export function instanceOfExpenseSummary(value: object): value is ExpenseSummary {
    if (!('amountWithoutFeesAndTaxes' in value) || value['amountWithoutFeesAndTaxes'] === undefined) return false;
    if (!('serviceFeesWithoutTaxes' in value) || value['serviceFeesWithoutTaxes'] === undefined) return false;
    if (!('amountWithoutTaxes' in value) || value['amountWithoutTaxes'] === undefined) return false;
    if (!('taxes' in value) || value['taxes'] === undefined) return false;
    if (!('amountTotalWithFeesAndTaxes' in value) || value['amountTotalWithFeesAndTaxes'] === undefined) return false;
    if (!('shouldDisplayFees' in value) || value['shouldDisplayFees'] === undefined) return false;
    return true;
}

export function ExpenseSummaryFromJSON(json: any): ExpenseSummary {
    return ExpenseSummaryFromJSONTyped(json, false);
}

export function ExpenseSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpenseSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'amountWithoutFeesAndTaxes': json['amountWithoutFeesAndTaxes'],
        'serviceFeesWithoutTaxes': json['serviceFeesWithoutTaxes'],
        'amountWithoutTaxes': json['amountWithoutTaxes'],
        'taxes': json['taxes'],
        'amountTotalWithFeesAndTaxes': json['amountTotalWithFeesAndTaxes'],
        'shouldDisplayFees': json['shouldDisplayFees'],
    };
}

export function ExpenseSummaryToJSON(value?: ExpenseSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'amountWithoutFeesAndTaxes': value['amountWithoutFeesAndTaxes'],
        'serviceFeesWithoutTaxes': value['serviceFeesWithoutTaxes'],
        'amountWithoutTaxes': value['amountWithoutTaxes'],
        'taxes': value['taxes'],
        'amountTotalWithFeesAndTaxes': value['amountTotalWithFeesAndTaxes'],
        'shouldDisplayFees': value['shouldDisplayFees'],
    };
}

